// Api Localhost
//export const ROOT_PATH = "http://localhost:5000/api/";
// Api Servidor
export const ROOT_PATH = "http://138.201.60.50:5000/api/";
